<template>
    <div>
		<!-- New SSO Sign Up -->
		        <b-modal v-model="bulk_modals.show_sign_up_sso" v-if="bulk_selection.length === 1" 
				no-close-on-backdrop ref="signup"
				:title="modal_title_email_change" :ok-title="action_button_label" @ok="assignUserEmail(bulk_selection,$event)" :ok-disabled="!signUpButtonStatus()" @cancel="closeModal">
			<!-- Need to decide when to show this -->
			<template>
				<template>
					<p class="text-center">You will {{action_button_label}} {{ bulk_selection[0].last_name }} {{ bulk_selection[0].first_name }} </p>
				</template>
				<template>
					<div class="form-group margin-bottom-negative-10 ml-3">
	
						<div class="row">
							<div class="col">
								<label for="exampleInputEmail1">Current Email</label>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-8">
								<input :disabled="true"
								 v-model="bulk_selection[0].email" type="text" class="form-control" id="newEmailProvider" 
                                ref="newEmail"
                                value="new-Email"
                                aria-describedby="emailHelp" placeholder="Current email">
							</div>
                           
						</div>
						<div class="row">
							<div class="col">
								<label for="exampleInputEmail1">New Email</label>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-8">
								<input v-model.trim="user_signup.email" type="text" class="form-control" id="newEmailProvider" 
                                ref="signUpEmail"
                                value="signup-Email"
                                aria-describedby="emailHelp" placeholder="New email">
								
							</div>
							<button  class="button copyclipboard mr-2" :class="{'input-disabled': !user_signup.email}"  @click="copyEmail"><i class="fa fa-clipboard" aria-hidden="true" style="vertical-align: baseline"></i></button>
                            <button class="button copyclipboard" :class="{'input-disabled': !user_signup.email}" @click="checkEmail()">Check Email</button>
						</div>
			

						<div class="row">
							<div class="col">
								<label for="exampleInputEmail1">Password</label>

							</div>
							
						</div>
						<div class="row">
							<div class="col-lg-8">
								<input :disabled="!enable_password" v-model="generatedPassword" @input="checkPassword" type="text" class="form-control" id="newPassword" 
                                ref="newPass2"
                                value="new-Password"
                                aria-describedby="emailHelp" placeholder="Enter New Password">
								
							</div>
                            <button :disabled="!enable_password" class="button copyclipboard" :class="{'input-disabled': !generatedPassword || !enable_password}"  @click="copyPassword2"><i class="fa fa-clipboard" aria-hidden="true" style="vertical-align: baseline"></i></button>
						
								<b-container fluid style="display:contents;">						
									<b-col>
										<b-button v-b-tooltip.hover.righttop="'A password must contain :	'+ 
										 '- At least *6* characters		'+
											'At least charactes from *2* groups (letters, digits, special signs)'
											+'Password can not contain:		'
											+'First name, Last name, Employer Number'+
											'Consucutive letters or digits (i.e. 1234, abcd)'
											+'Identical letters or digits (i.e. aaaa, 0000)!'" variant="primary"><i class="fa fa-question-circle" aria-hidden="true"></i></b-button>
									</b-col>
								</b-container>
							
						</div>
						<!-- Tooltip section -->
						<small style="position: relative; top: 0px;" id="emailHelp" class="form-text text-muted">We'll never share your 	password with anyone else.</small>
					</div>
						<b-button class="ml-3 mt-3" :class="{'input-disabled': !enable_password}" :disabled="!enable_password" @click="generatePassword" variant="info">Generate New Password</b-button>		
				</template>
				<hr/>
				<div v-if="email_warnings.length>0">
					Email:
					<ul :class="{'green2': email_verified && enable_action_button }" class="error-msg ml-3">
						<li v-for="warning_email in email_warnings" :key="warning_email">
							{{warning_email}}
						</li>
					</ul>
				</div>
				<div v-if="password_error && generatedPassword.length>0">
					Password:
					<ul class="error-msg ml-3">
						<li v-for="warning in password_warnings" :key="warning">
							{{warning}}
						</li>
					</ul>
				</div>
				
			</template>
			
		</b-modal>


		<!-- Send SMS modal -->
		<b-modal v-model="bulk_modals.show_send_sms" title="Send SMS" @ok="sendSMS" no-close-on-backdrop
		v-if="bulk_selection.length >= 1 || (select_all === true)" 
		ok-title="Send" cancel-title="Cancel">	
	    	<p>Send message to :</p>
			<template>
			<template v-if="select_all">
				<p v-if="bulk_selection.length == 0 " class="text-center">You will send message to <b>all</b> employees under current agency</p>
				<p v-else class="text-center">You will send message to {{bulk_selection.length}} employees under current agency</p>
			</template>
	    	<template v-else>
	    		<ul class="list-unstyled text-center">
					<li v-for="provider in bulk_selection">
						 {{ provider.last_name }} {{ provider.first_name }}
					</li>
				</ul>
	    	</template>
	    
			

			<div class="input-content mb-2">
				<pre><textarea rows="13" :disabled="disable_text_modift" v-model="bulk_message_text"><pre></pre></textarea></pre>
				<span v-if="selected_message == null || selected_message == '' " class="chracter-count-section" :class="{'danger': bulk_message_text.length> 150}">
					 {{bulk_message_text.length}}
				</span>
			</div>
			<div>
				<label>Pre-defined Messages</label>
				<v-select @input="selectCannedMessage($event)" :searchable="true" track-by="value" label="name" :options="canned_messages" v-model="selected_message" class="green bg-gray v-select-no-height"  ></v-select>
					<!-- -->
			</div>

			<small>
				<p class="mt-2 mb-1">You can personalize the message with: </p>
				<ul>
					<li>%FIRST_NAME%: first name of the employee</li>
					<li>%LAST_NAME%: last name of the employee</li>
					<li>%EMAIL%: email of the employee</li>
				</ul>
			</small>
			</template>
		</b-modal>
		<!-- Reset Password Modals -->
        <b-modal v-model="bulk_modals.show_reset_password_text" v-if="bulk_selection.length >= 1 || (select_all === true)" title="Send Text Message to Change Password" ok-title="Send" no-close-on-backdrop @ok="sendTxtPasswordReset(bulk_selection)">
			<!-- Need to decide when to show this -->
			<template v-if="true">
				<template>
					<p v-if="select_all" class="text-center">You will reset the password for all employees in the program.</p>
					<p v-else class="text-center">You will send text message to change password of</p>
				</template>
				<template>
					<ul class="list-unstyled list-4-columns">
						<li v-for="provider in bulk_selection" class="text-center">
							 {{ provider.last_name }}  {{ provider.first_name }}
						</li>
					</ul>	
				</template>
			</template>
		</b-modal>
        <!-- Show reset password email -->
        <b-modal v-model="bulk_modals.show_reset_password_email" v-if="bulk_selection.length >= 1 || (select_all === true)" title="Send Email to Change Password" ok-title="Send" @ok="sendEmailPasswordReset(bulk_selection)" @hide="resetEmailModal" @cancel="resetEmailModal">
			<!-- Need to decide when to show this -->
			<template v-if="true">
				<template>
					<p v-if="select_all" class="text-center">You will send email to change password for all employees in the program.</p>
					<p v-else class="text-center">You will send email to change password of</p>
				</template>
				<template>
					<ul class="list-unstyled list-4-columns">
						<li v-for="provider in bulk_selection" class="text-center">
							 {{ provider.last_name }}  {{ provider.first_name || provider.name }}
						</li>
					</ul>			
				</template>
			</template>
		</b-modal>

        <!-- Generate Password -->

        <b-modal v-model="bulk_modals.show_reset_password_plain" v-if="bulk_selection.length === 1" no-close-on-backdrop title="Change Password" ok-title="Change" @cancel="resetEmailModal" @ok="resetPasswordPlain(bulk_selection, $event)" ref="reset-plain" :ok-disabled="password_error">
			<!-- Need to decide when to show this -->
			<template>
				<template>
					<p class="text-center">You will change password of</p>
				</template>
				<template>
					<ul class="list-unstyled list-4-columns">
						<li v-for="provider in bulk_selection" class="text-center">
							 {{ provider.last_name }}  {{ provider.first_name || provider.name }}
						</li>
					</ul>	

					<div class="form-group">
						<div class="row">
							<div class="col">
								<label for="exampleInputEmail1">Create New Password</label>
							</div>
							<div class=".col-6 .col-md-4">
								<b-container fluid>						
									<b-col>
										<b-button v-b-tooltip.hover.righttop="'A password must contain :	'+ 
										 '- At least *6* characters		'+
											'At least characters from *2* groups (letters, digits, special signs)'
											+'Password can not contain:		'
											+'First name, Last name, Employer Number'+
											'Consucutive letters or digits (i.e. 1234, abcd)'
											+'Identical letters or digits (i.e. aaaa, 0000)!'" variant="primary"><i class="fa fa-question-circle" aria-hidden="true"></i></b-button>
									</b-col>
								</b-container>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-8">
								<input v-model="generatedPassword" @input="checkPassword" type="text" class="form-control" id="newPassword" 
                                ref="newPass"
                                value="new-Password"
								v-validate="'required'" 
                                aria-describedby="emailHelp" placeholder="Enter New Password">
								<ul v-if="password_error" class="error-msg ml-3">
									<li v-for="warning in password_warnings" :key="warning">
										{{warning}}
									</li>
								</ul>
							</div>
                            <button class="button copyclipboard"  @click="copyPassword"><i class="fa fa-clipboard" aria-hidden="true" style="vertical-align: baseline"></i></button>
						</div>
						<!-- Tooltip section -->
						<small id="emailHelp" class="form-text text-muted">We'll never share your 	password with anyone else.</small>
					</div>
						<b-button @click="generatePassword" variant="info">Generate New Password</b-button>		
				</template>
			</template>
		</b-modal>
    </div>
</template>
<script>
export default {
    props:["bulk_modals","bulk_selection", "select_all", "agency_id", "filter_status", "search_key", "type"],
    data: function(){
        return{
            generatedPassword:'',
			bulk_message_text:'',
			email_verified:false,
			password_verified: false,
			valid_password:false,

			contains_number:false,
			consecutive_number_letter:false,
			contains_six_character:false,
			identical: false,

			router_obj:{
				params:'',
				query:{ 
					agency_id:'',
					sign_up:''
				}
			},
			password_warnings:[],
			password_error: false,
			user_signup:{
				email:'',
				message:''
			},
			enable_action_button: false,
			password_mandatory: false,
			enable_password: true,
			email_warnings: [],
			canned_messages: [],
			selected_message:'',
			disable_text_modift: false


        }
    },
    created : function(){
		if(this.generatedPassword != ''){
			this.generatedPassword =''
		}
		this.router_obj = this.$route
    },
	watch:{
		bulk_selection:{
			handler: function(newWal){
			
				if(newWal.length>0){
					if(newWal[0].email != ''){
					this.email_verified = this.verifyEmail(newWal[0].email)
					}
				}
			},
			deep: true
		},
		selected_message: function(val){
			if(!val){
				this.bulk_message_text = ''
				this.disable_text_modift = false
			}
		},
		'bulk_modals.show_send_sms': function(val){
			if(val){
				this.getCannedMessages()
			}
		}
	},
	computed:{
		action_button_label(){
 			return (!this.bulk_selection[0].email) ? 'SignUp' : 'Edit'
		},
		modal_title_email_change(){
			return this.action_button_label + ' User'
		},
		encodedStr(){ 
			if(this.generatedPassword){
				return btoa((this.generatedPassword+this.config.PASSWORD_SALT))
			}
		}
	},
    methods:{
		selectCannedMessage(event){
			if(event){
				this.bulk_message_text = event.texts['EN']
				this.disable_text_modift = true
			}
		},
		getCannedMessages(){
            var params = {}
            this.$store.dispatch('getCannedMessages', params).then((res) =>{
                this.canned_messages = res.data.data
            }).catch((error) => {
                console.log(error)
            })
        },
		signUpButtonStatus: function(){
			if(!this.password_mandatory && this.enable_action_button){
				return true
			}
			else if(this.password_mandatory && this.generatedPassword == ''){
				return false
			}
			else if(!this.email_verified || this.password_error || !this.enable_action_button){
				return false
			}else{
				return true
			}
		},
		verifyEmail: function(val){
			var trimmed_email = val.replace(/\s/g, "");
			this.user_signup.email = trimmed_email
			const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
			this.email_verified = regex.test(trimmed_email)
		},
		resetEmailModal: function(){
			this.closeModal()
			this.$emit('resetEmailModal')
		},
		check_consecutive: function(str){
			if(str===''){
				return false
			}
			let temp_arr = [...str];
			temp_arr.sort();
			for(let i = 1; i< temp_arr.length; i++){
				if(isNaN(temp_arr[i] - temp_arr[i-1])){
					if(temp_arr[i].charCodeAt(0) - temp_arr[i-1].charCodeAt(0) != 1){
						return false
					}
				}else{
					if(temp_arr[i] - temp_arr[i-1] != 1){
						return false
					}
				}
				return true
			}

		},
		checkEmail: function(){
			this.verifyEmail(this.user_signup.email)
			if(this.email_verified){
				var params = {
					filters:{
						new_email: this.user_signup.email,
					},
					provider_id: this.bulk_selection[0].id
				}
				this.$store.dispatch('checkEmail', params).then((res) =>{
					this.email_warnings = res.data.message_text
					this.password_mandatory = res.data.password_mandatory
					this.enable_password = res.data.enable_password
					this.enable_action_button = res.data.enable_action_button
				})
			}else{
				this.email_warnings = ["Email is not verified"]
				this.enable_action_button = false
			}
	
		},
		checkPassword: function(){
			var params = {
				filters:{
					password: this.encodedStr,
					page_loading : false
				}
			}
			this.$store.dispatch('validatePassword', params).then((res) =>{
				this.password_warnings = res.data.password_message
				this.password_error = res.data.error
			})
	
		},
        sendTxtPasswordReset: function(provider){
            let user_id = provider[0].id
            var params = {
					id: user_id,
					filters:{
						type: 'provider',
						sms:1
					}
			}

            var toast = this.$snotify.info('Resetting Password...', {
                timeout : 0
            });

            this.$store.dispatch('sendResetPasswordEmail', params).then((res) => {
   
                if(res.data.url){
                    window.open(res.data.url, '_blank');
                }				
                setTimeout( () => {
                    this.$snotify.remove(toast.id);
                }, 500);
            }).catch((error) => {
                setTimeout( () => {
                    this.$snotify.remove(toast.id);
                }, 500);
                console.log(error)
            })
            //var checks = this.$refs['bulk-checks'];

        },
        sendEmailPasswordReset: function(provider){
            let user_id = provider[0].id
				var params = {
				id: user_id,
				filters:{
					type: this.type != null ? this.type : 'provider'
					}
				}
				var toast = this.$snotify.info('Resetting Password...', {
					timeout : 0
				});
				
				this.$store.dispatch('sendResetPasswordEmail', params).then((res) => {

					if(res.data.url){
						window.open(res.data.url, '_blank');
					}				
					setTimeout( () => {
						this.$snotify.remove(toast.id);
					}, 500);
				}).catch((error) => {
                    setTimeout( () => {
						this.$snotify.remove(toast.id);
					}, 500);
					console.log(error)
				})
				//var checks = this.$refs['bulk-checks'];

        },
        generatePassword: function(){
				this.generatedPassword = ''
				this.$store.dispatch('generatePassword').then((res) => {
					let decoded = atob((res.data))
					this.generatedPassword = decoded.replace(this.config.PASSWORD_SALT,'')
					this.checkPassword();
				})
		},
        resetPasswordPlain: function(provider, evt){
			var dispatch_call = (this.type != null ? 'setPasswordUser' : 'setPassword')
			let user_id = provider[0].id
			var params = {
				filters:{
					user_id:user_id,
					password:this.encodedStr
				}
			}
			evt.preventDefault()
			this.$validator.validateAll().then((result) =>{
				if(!result){
					this.valid_password = true
				}else{
					this.$store.dispatch(dispatch_call,params ).then((res)=>{
						this.loading_table_providers = false;
						this.email_warnings = res.data.message
						this.$nextTick(() => {
							this.valid_password = false
							this.$refs['reset-plain'].hide()
								})
					}).catch((error) => {
						console.log(error)
						if(error.status != 404){
							this.valid_password = true
						}
					});
				this.resetEmailModal()
				
			}})
			
        },
        copyPassword: function(){
            let testingCodeToCopy = this.$refs.newPass
            testingCodeToCopy.innerHTML = window.location.href;
            testingCodeToCopy.select();
            document.execCommand("copy");

        },
		copyPassword2: function(){
			let testingCodeToCopy = this.$refs.newPass2
            testingCodeToCopy.innerHTML = window.location.href;
            testingCodeToCopy.select();
            document.execCommand("copy");
		},
		copyEmail: function(){
			let testingCodeToCopy = this.$refs.signUpEmail
            testingCodeToCopy.innerHTML = window.location.href;
            testingCodeToCopy.select();
            document.execCommand("copy");
		},
		sendSMS: function(){
			//if user select all but not filtered - send everyone
			if(this.select_all && this.filter_status != 'Filtered' && this.search_key == ''){
				var params = {
					provider_ids: [],
					organization_id: this.agency_id,
					all:1
				}
			}else{
				// check the selected providers is an obj or array
				if(this.bulk_selection.length > 0){
					let provider_ids = (typeof this.bulk_selection[0] == 'object') ? this.bulk_selection.map(a=>a.id) : this.bulk_selection
					var params = {
						provider_ids: provider_ids,
						organization_id: this.agency_id
					}

				}
			}
			if(this.selected_message != null && this.selected_message != undefined && this.selected_message != ''){
				params.template_id = this.selected_message.id
			}else{
				params.text = this.bulk_message_text
			}

			this.$store.dispatch('providerBulkSMS', params).then((res)=>{
					this.bulk_message_text = ''
					this.selected_message = null
					this.$emit('closeLoadingTableIcon')
				
			}).catch((error) => {
				console.log(error)
			})

		

		},
		assignUserEmail: function(provider,evt){
			evt.preventDefault()
			// need id, email, password, org_id
			var params = {
				id : provider[0].id,
				credentials : {
					new_email : this.user_signup.email,
					password : this.encodedStr || null
				}
			}
			this.$store.dispatch('assignUserEmailCredentials', params).then((res)=>{
				if(this.action_button_label == 'SignUp'){
					this.$emit('updateProviderSignUp')
				}

			}).catch((error) => {
				if(error.status != 404){
					this.valid_password = true
				}
			})
			this.$emit('updateProviderEmail', this.user_signup.email)
			this.closeModal();

		},
		closeModal: function(){
			this.enable_action_button = false
			this.password_mandatory = false
			this.password_warnings = []
			this.email_warnings = []
			this.user_signup.email = ''
			this.user_signup.message = ''
			this.generatedPassword = ''
			this.$emit('closeBulkModal', 'sign_up_sso')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/shared/PasswordDropdown.vue